import { AiOff, Card, PageHead } from '@/components/ui';

export function DemandPage() {
  return (
    <div className="page">
      <PageHead title="Demand" subtitle="What customers ask for, and how often we deliver it" />
      <Card>
        <AiOff what="Demand" />
        <div className="note" style={{ textAlign: 'center' }}>
          Demand groups asks by intent (build a forecast, ask for a number, compare to budget…) and shows how often each
          is delivered. Intents come from AI analysis.
        </div>
      </Card>
    </div>
  );
}
